import React, { ReactElement } from 'react';

interface IIconLockProps {
	className?: string;
	size?: string;
	altText?: string;
}

const IconLock = ({
	size = 'large',
	className = '',
	altText = 'Lock Icon',
}: IIconLockProps): ReactElement => {
	switch (size) {
		case 'large':
			return (
				<svg
					className={`IconLock icon ${className}`}
					width='24'
					height='24'
					viewBox='0 0 24 24'
					fill='currentColor'
					xmlns='http://www.w3.org/2000/svg'
					aria-label={altText}
				>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M11.7826 1C15.219 0.997705 18.0291 3.54733 18.1547 6.72494L18.1591 6.94254L18.1617 9.95165H18.8091C19.9647 9.95165 20.9143 10.7859 20.9947 11.8446L21.0002 11.9903V20.9516C21.0026 22.0295 20.1059 22.9129 18.9705 22.9876L18.8143 22.9928L5.19114 23C4.03546 23 3.0859 22.1636 3.00552 21.1047L3 20.959V12.0001C2.9976 10.9222 3.89431 10.0389 5.02966 9.96197L5.1859 9.95654L5.86421 9.95165L5.85897 6.94254C5.85635 3.66454 8.26802 1.00254 11.7826 1ZM12 14.7501C11.8135 14.75 11.6349 14.8232 11.5046 14.953C11.4004 15.0568 11.3341 15.1899 11.3141 15.3318L11.3078 15.4396V16.8026C11.3034 16.9847 11.3741 17.161 11.5042 17.292C11.6342 17.4231 11.8128 17.498 12 17.5001C12.3558 17.4921 12.6448 17.2301 12.6869 16.8955L12.6922 16.8026V15.4396C12.6944 15.2589 12.6227 15.0847 12.4929 14.9554C12.3631 14.826 12.1858 14.7522 12 14.7501ZM8.14567 7.31854C8.2139 5.14086 9.41173 3.00009 11.9959 3.00009C14.6585 3.00009 15.8518 5.26992 15.8518 7.51125L15.8569 9.95654L8.14759 9.96183L8.14257 7.51655L8.14567 7.31854Z'
					/>
				</svg>
			);
		case 'medium':
			return (
				<svg
					className={`IconLock icon ${className}`}
					width='20'
					height='20'
					viewBox='0 0 20 20'
					fill='currentColor'
					xmlns='http://www.w3.org/2000/svg'
					aria-label={altText}
				>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M9.81881 0.833497C12.6825 0.831583 15.0242 2.95627 15.1289 5.60428L15.1326 5.78561L15.1348 8.29321H15.6742C16.6373 8.29321 17.4286 8.98839 17.4956 9.87067L17.5002 9.99209V17.4599C17.5022 18.3581 16.7549 19.0942 15.8088 19.1565L15.6786 19.1608L4.32595 19.1668C3.36289 19.1668 2.57159 18.4699 2.5046 17.5874L2.5 17.466V10.0002C2.498 9.102 3.24526 8.3659 4.19139 8.30181L4.32159 8.29728L4.88684 8.29321L4.88248 5.78561C4.88029 3.05395 6.89002 0.835614 9.81881 0.833497ZM9.99999 12.2919C9.8446 12.2919 9.69576 12.3528 9.58719 12.461C9.50032 12.5475 9.4451 12.6584 9.42839 12.7767L9.42317 12.8665V14.0023C9.41949 14.1541 9.47842 14.301 9.58679 14.4102C9.69517 14.5194 9.84397 14.5818 9.99999 14.5836C10.2965 14.5769 10.5373 14.3585 10.5724 14.0797L10.5768 14.0023V12.8665C10.5786 12.7159 10.5189 12.5707 10.4107 12.463C10.3025 12.3552 10.1548 12.2937 9.99999 12.2919ZM6.78806 6.09894C6.84491 4.28421 7.84311 2.50024 9.99662 2.50024C12.2154 2.50024 13.2099 4.39176 13.2099 6.25954L13.214 8.29728L6.78966 8.30169L6.78548 6.26395L6.78806 6.09894Z'
					/>
				</svg>
			);
		default:
			return (
				<svg
					className={`IconLock icon ${className}`}
					width='16'
					height='16'
					viewBox='0 0 16 16'
					fill='currentColor'
					xmlns='http://www.w3.org/2000/svg'
					aria-label={altText}
				>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M7.85505 0.666505C10.146 0.664974 12.0194 2.36472 12.1031 4.48313L12.1061 4.6282L12.1078 6.63427H12.5394C13.3098 6.63427 13.9429 7.19042 13.9965 7.89624L14.0001 7.99338V13.9676C14.0017 14.6862 13.4039 15.2751 12.647 15.3249L12.5429 15.3283L3.46076 15.3332C2.69031 15.3332 2.05727 14.7756 2.00368 14.0696L2 13.9725V7.9999C1.9984 7.28131 2.59621 6.69243 3.35311 6.64115L3.45727 6.63753L3.90948 6.63427L3.90598 4.6282C3.90423 2.44286 5.51201 0.668198 7.85505 0.666505ZM7.99999 9.83323C7.87568 9.8332 7.75661 9.88197 7.66975 9.96849C7.60026 10.0377 7.55608 10.1264 7.54271 10.221L7.53854 10.2929V11.2016C7.53559 11.323 7.58273 11.4405 7.66943 11.5278C7.75613 11.6152 7.87518 11.6652 7.99999 11.6666C8.2372 11.6612 8.42987 11.4865 8.45796 11.2635L8.46145 11.2016V10.2929C8.46291 10.1724 8.41512 10.0563 8.32858 9.97007C8.24204 9.88387 8.12384 9.83464 7.99999 9.83323ZM5.43045 4.87886C5.47593 3.42708 6.27449 1.9999 7.9973 1.9999C9.77231 1.9999 10.5679 3.51312 10.5679 5.00734L10.5712 6.63753L5.43173 6.64106L5.42838 5.01087L5.43045 4.87886Z'
					/>
				</svg>
			);
	}
};

export default IconLock;
